export const loading = (state) => state.loading
export const saving = (state) => state.saving
export const generating = (state) => state.generating
export const pending = (state) => state.pending
export const typeModule = (state) => state.typeModule
export const modeInvite = (state) => state.modeInvite



// WEBPACK FOOTER //
// ./src/store/modules/actionState/getters.js